<template>
  <div>
    <div class="discount-banner">
      <h2
        class="discount-banner__header"
        v-if="showDiscountPasses && !showingPassesBelow"
      >
        {{ $t("discount-banner.standard-name") }}
      </h2>
      <h2 class="discount-banner__header" v-else>
        {{ $t("discount-banner.name") }}
      </h2>
      <div class="discount-banner__text">
        <p v-if="showDiscountPasses && !showingPassesBelow">
          <img
            v-if="$t('discount-banner.standard-image') !== ''"
            :src="`${publicPath}img/${$t('discount-banner.standard-image')}`"
          />
          {{ $t("discount-banner.standard-description") }}
        </p>
        <p v-else>
          <img :src="`${publicPath}img/${$t('discount-banner.image')}`" />
          {{ $t("discount-banner.description") }}
        </p>
      </div>
      <div class="discount-banner__button" v-if="!showingPassesBelow">
        <button
          @click.prevent="$emit('toggle')"
          v-if="showDiscountPasses"
          class="button"
        >
          {{ $t("discount-banner.standard-button") }}
        </button>
        <button
          @click.prevent="$emit('toggle')"
          v-else
          class="button"
        >
          {{ $t("discount-banner.button") }}
        </button>
      </div>
      <p
        class="discount-banner__below"
        v-if="$t('discount-banner.below-text') !== ''"
      >
        <img
          v-if="$t('discount-banner.below-image') !== ''"
          class="left"
          :src="`${publicPath}img/${$t('discount-banner.below-image')}`"
        />
        {{ $t("discount-banner.below-text") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showDiscountPasses: Boolean,
    showingPassesBelow: Boolean,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    systemId() {
      return this.$store.state.systemId;
    },
  },
};
</script>
